import { z } from 'zod';
import { ORGANIZATION_STATUSES } from '@artemis/domain';
export const organizationStatusSchema = z.enum(ORGANIZATION_STATUSES);
export { ORGANIZATION_STATUSES, ALLOWED_TRANSITIONS, canTransitionOrganizationStatus, ORGANIZATION_START_STATUSES, isOrganizationStartStatus, } from '@artemis/domain';
//# sourceMappingURL=organization-status.js.map